import { render, staticRenderFns } from "./html.vue?vue&type=template&id=d020396e&scoped=true&"
import script from "./html.vue?vue&type=script&lang=ts&"
export * from "./html.vue?vue&type=script&lang=ts&"
import style0 from "./html.vue?vue&type=style&index=0&id=d020396e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d020396e",
  null
  
)

export default component.exports